<template>
    <div>
        <SupplierTable />
    </div>
</template>

<script>
import SupplierTable from '@/components/supplier/SupplierTable.vue'
export default {
    components: {
        SupplierTable
    },
    name: 'Suppliers'
}
</script>